import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'beanbuzz_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p>
            We use cookies to enhance your experience on BeanBuzz. Essential cookies are required
            for the platform to function, while analytics cookies help us improve our services.
            For more details, see our{' '}
            <Link to="/privacy" className="cookie-consent-link">Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="btn btn-primary cookie-consent-accept"
            onClick={handleAccept}
          >
            Accept All
          </button>
          <button
            className="btn btn-ghost cookie-consent-decline"
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
